import Solution from "./solution";
// import compare from "../../Utils/compare";

const testCases = [
  {
    date1: "10/15/2020",
    date2: "12/1/2020",
  },
  {
    date1: "2022-01-30",
    date2: "12/1/2020",
  },
  {
    date1: "2022-01-30",
    date2: "2022-03-30",
  },
  {
    date1: "12/1/2020",
    date2: "2021-01-30",
  },
  {
    date1: "09/1/2020",
    date2: "07/1/2020",
  },
];

const test = (code) => {
  try {
    const updatedFunc = `${code.trim()}`;
    const output = new Function(updatedFunc);
    for (let test of testCases) {
      const { date1, date2 } = test;
      let outcome1 = output()(date1, date2);
      let outcome2 = Solution(date1, date2);
      const result = outcome1 === outcome2;
      if (!result) {
        return {
          status: "failed",
          details: { input: test, output: outcome1, expected: outcome2 },
        };
      }
    }

    return { status: "success", details: {} };
  } catch (e) {
    return {
      status: "error",
      details: { message: `${e.name}: ${e.message}` },
    };
  }
};

export default test;
